export const properSectionWithNextButtonLength = 2;
